/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Live_BoardInputs */

const en_directory_vibebids_live_board = /** @type {(inputs: Directory_Vibebids_Live_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live board`)
};

const zh_directory_vibebids_live_board = /** @type {(inputs: Directory_Vibebids_Live_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时榜单`)
};

/**
* | output |
* | --- |
* | "Live board" |
*
* @param {Directory_Vibebids_Live_BoardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_live_board = /** @type {((inputs?: Directory_Vibebids_Live_BoardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Live_BoardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_live_board(inputs)
	return zh_directory_vibebids_live_board(inputs)
});
export { directory_vibebids_live_board as "directory.vibebids.live_board" }